export const onlyNumbers = (value: string): string => {
    return value.replace(/\D/g, '')
}

export function getDistinctValues(array: string[]): string[] {
    const hashTable: { [value: string]: boolean } = {};

    for (const value of array) {
        // Adiciona o valor na tabela hash se ele ainda não foi adicionado antes
        if (!hashTable[value]) {
            hashTable[value] = true;
        }
    }
    // Retorna o número de valores distintos na tabela hash
    return Object.keys(hashTable);
}